import React from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faLock} from "@fortawesome/free-solid-svg-icons";

const Lock = (): JSX.Element => <FontAwesomeIcon icon={faLock} />

export default Lock;
